import { getBaseUrl, getPageUrl } from 'utils/getBaseUrl';

export const orgId = (): string => `${getBaseUrl()}/#organization`;
export const websiteId = (): string => `${getBaseUrl()}/#website`;

const lastSegment = (gid: string): string => gid.split('/').pop() ?? gid;

export const productId = (pagePath: string): string =>
  `${getPageUrl(pagePath)}#product`;

export const variantOfferId = (pagePath: string, variantId: string): string =>
  `${getPageUrl(pagePath)}#offer-${lastSegment(variantId)}`;

export const subscriptionOfferId = (
  pagePath: string,
  variantId: string,
  sellingPlanId: string,
): string =>
  `${getPageUrl(pagePath)}#offer-${lastSegment(variantId)}-sub-${lastSegment(
    sellingPlanId,
  )}`;

export const articleId = (pagePath: string): string =>
  `${getPageUrl(pagePath)}#article`;

export const podcastEpisodeId = (pagePath: string): string =>
  `${getPageUrl(pagePath)}#episode`;

export const faqPageId = (pagePath: string): string =>
  `${getPageUrl(pagePath)}#faqpage`;

export const faqBlockId = (pagePath: string): string =>
  `${getPageUrl(pagePath)}#faq`;

export const productFaqId = (pagePath: string): string =>
  `${getPageUrl(pagePath)}#productfaq`;
